export default __webpack_public_path__ + "static/media/pic_ai_6.937d0baa.png";